import { FacebookPageViewModel } from './facebookPageView.model';

export class FacebookViewContentModel extends FacebookPageViewModel {}
